import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.dataProcessingMergeProgress;

const DataProcessingMergeProgressData = createSelector([selector], (state) => state);

export default {
  DataProcessingMergeProgressData
};
